import { render } from "./PuzzleLadderPractice.vue?vue&type=template&id=06f78cbc"
import script from "./PuzzleLadderPractice.vue?vue&type=script&lang=js"
export * from "./PuzzleLadderPractice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__